(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('responsive-video')) {

    class ResponsiveVideo extends HTMLElement {

      connectedCallback() {

        this.desktopTemplate = this.querySelector(
          '[data-desktop-video]'
        );

        this.mobileTemplate = this.querySelector(
          '[data-mobile-video]'
        );

        this.mediaQuery = window.matchMedia(
          '(max-width: 749px)'
        );

        this.currentBreakpoint = null;

        this.activeMedia = null;

        this.handleBreakpointChange =
          this.handleBreakpointChange.bind(this);

        this.renderActiveVideo();

        this.mediaQuery.addEventListener(
          'change',
          this.handleBreakpointChange
        );
      }


      disconnectedCallback() {

        this.mediaQuery?.removeEventListener(
          'change',
          this.handleBreakpointChange
        );

      }


      handleBreakpointChange() {

        this.renderActiveVideo();

      }


      renderActiveVideo() {

        const breakpoint = this.mediaQuery.matches
          ? 'mobile'
          : 'desktop';

        if (breakpoint === this.currentBreakpoint) {
          return;
        }


        const template = breakpoint === 'mobile'
          ? this.mobileTemplate
          : this.desktopTemplate;


        if (!template) {
          return;
        }


        /*
         * Remove the previously active deferred-media
         * from the live DOM.
         *
         * The templates themselves remain untouched and inert.
         */
        if (this.activeMedia) {
          this.activeMedia.remove();
          this.activeMedia = null;
        }


        /*
         * Clone ONLY the video needed for this breakpoint.
         */
        const fragment = template.content.cloneNode(true);

        const activeElement = fragment.firstElementChild;


        /*
         * Insert it directly as a child of responsive-video.
         * responsive-video uses display: contents, so there is
         * no extra layout box around deferred-media.
         */
        this.appendChild(fragment);

        this.activeMedia = activeElement;
        this.currentBreakpoint = breakpoint;

      }

    }


    customElements.define(
      'responsive-video',
      ResponsiveVideo
    );

  }
  } catch(e) { console.error(e); }
})();

})();
